import styled, { Font, Spacing, Breakpoint } from '@nfinite/react-hubstairs/styled'

import { SPACING_BOTTOM_PAGE } from 'components/Commons/PageContent/Content/styled'
import { Search as SearchComponent } from 'components/Commons/PaginatedList'

import { ToggleStandalone } from 'components/Commons/Inputs/Toggle'
import { OrganizationLogoWrapper } from 'components/Organization/LogoWrapper'

export const Container = styled('div')`
  ${Spacing.generatePadding({ horizontal: 'l' })}
`

export const Content = styled('div')`
  padding-bottom: ${SPACING_BOTTOM_PAGE}px;
`

export const FiltersContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${Spacing.generateMargin({ top: 'xxs', bottom: 'l' })}
  flex-direction: column;
  ${Breakpoint.greaterThan('xs')} {
    flex-direction: row;
  }
`

export const ToggleComponent = styled(ToggleStandalone)`
  margin-left: auto;
`

export const SearchWrapper = styled('div')`
  display: flex;
  width: min(380px, 100%);
  flex-shrink: 1;
`

export const Search = styled(SearchComponent)`
  flex-grow: 1;
  display: flex;
`

export const Results = styled('div')`
  ${Font.generate({ size: 's' })}
`

export const StyledLogoWrapper = styled(OrganizationLogoWrapper)`
  > :nth-child(1) {
    z-index: 1;
    top: 10%;
    left: -10%;
    ${Breakpoint.greaterThanMobile()} {
      top: calc(5% + 40px);
    }
  }
`
